module.exports = __webpack_public_path__ + "img/expired.3b48652c.svg";